import React from "react";
import { Avatar } from "@mui/material";

const AVATAR_COLORS = ["#7e57c2", "#26a69a", "#ef6c00", "#5c6bc0", "#ec407a", "#8d6e63", "#29b6f6", "#9ccc65"];

const initials = (name = "") =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("") || "?";

// Initials on a colour picked from the name, so a person looks the same everywhere.
const PersonAvatar = ({ name = "", size = 40, sx }) => {
  const hash = [...name].reduce((acc, ch) => (acc * 31 + ch.charCodeAt(0)) >>> 0, 0);
  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.4,
        fontWeight: 600,
        bgcolor: AVATAR_COLORS[hash % AVATAR_COLORS.length],
        color: "#fff",
        ...sx,
      }}
    >
      {initials(name)}
    </Avatar>
  );
};

export default PersonAvatar;
